import { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loader: FC = (): JSX.Element => (
	<Spin indicator={<LoadingOutlined spin style={{ fontSize: 24 }} />} />
);

export default Loader;
